import { render } from "./zhengcInfo.vue?vue&type=template&id=c415fc80&scoped=true"
import script from "./zhengcInfo.vue?vue&type=script&lang=js"
export * from "./zhengcInfo.vue?vue&type=script&lang=js"

import "./zhengcInfo.vue?vue&type=style&index=0&id=c415fc80&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c415fc80"]])

export default __exports__